import React, { useState, useEffect } from "react"
import Select from "react-select"
import Modal from "react-modal"

import { SingleOption, customStyles, parseBudat, getLocaleStringRoundedInt } from "../../utils/utils.js"
import { showGreyBackground, hideGreyBackground, scrollTo } from "../../utils/windows.js"
import { customModalStyles } from "../../utils/styles"
import { allMateriales } from "../../utils/materiales"

import errorIcon from "../../../assets/img/atencion_rojo.svg"
import closeIcon from "../../../assets/img/cross-icon.svg"
import chevronRight from "../../../assets/img/chevron-right.svg"

const styles = customModalStyles(20)
styles.content.padding = 0

export const NormalizacionEntradasMobile = ({ pedidosEspeciales, pedidoEspecialChange, erroresEspeciales }) => {
  const [editingPedido, setEditingPedido] = useState()

  const closeModal = () => {
    setEditingPedido()
    hideGreyBackground()
  }

  const showPedido = (pedido) => {
    showGreyBackground()
    scrollTo(0, 0)
    setEditingPedido(pedido)
  }

  return (
    <div className="hide-desktop">
      <div className="big-subtitle">
        NORMALIZACIÓN DE ENTRADAS
        <hr className="title-separator-line" />
      </div>
      <table className="responsive-table separated-th-table">
        <thead>
          <tr>
            <th>
              <div className="th-data two">Identificador<br />Entrada</div>
            </th>
            <th>
              <div className="th-data">Fecha</div>
            </th>
            <th>
              <div className="th-data">Hora</div>
            </th>
          </tr>
        </thead>
        <tbody>
          { pedidosEspeciales.map(pedido=>
            <tr key={pedido.ID_PEDIDO}>
              <td>{pedido.ID_PEDIDO}</td>
              <td>
                {parseBudat(pedido.FECHA)}
              </td>
              <td>
                {pedido.HORA}
                <a className="show-mobile-details">
                  <img src={chevronRight} onClick={() => showPedido(pedido)} />
                </a>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {
        erroresEspeciales.map((error) =>
        <div className="table-bottom-error" key={error}>
          <img src={errorIcon} alt="error" />
          <p>{error}</p>
        </div>
      )}      
    
      {editingPedido &&
        <Modal isOpen={true} onRequestClose={closeModal} style={styles} className="responsive-modal">
          <div className="mobile-filters__title responsive-filters">
            <h1 className="responsive-modal-title">Normalización de Entradas</h1>
            <button className="mobile-filters__close-btn" onClick={closeModal}>
              <img src={closeIcon} alt="close modal" />
            </button>
          </div>
          <div className="mobile-filters__main-section">

          { editingPedido.DESCARGAS[0].TANQUES.map((tanque, tanqueKey) =>
            <div className="asignacion-entradas-descarga" key={`${editingPedido.DESCARGAS[0].material}-${editingPedido.DESCARGAS[0].compartimiento}`}>
              <span>{tanque.tipo==="tanque"?"Tanque":"Camión"} {tanque.tanque}</span>
              <span> /
                { allMateriales[editingPedido.DESCARGAS[0].material] ?
                  allMateriales[editingPedido.DESCARGAS[0].material].titleCierre: editingPedido.DESCARGAS[0].material
                }
              </span>
              <span>/ VOLUMEN (LTS): {tanque.volumen}</span>
              <input 
                className="mobile-input" 
                type="text" 
                onChange={(e) => pedidoEspecialChange(e.target.value, editingPedido, editingPedido.DESCARGAS[0], tanque, 0)} 
                value={tanque.volumen} 
              />

            </div>
          )}

          </div>
          <div className="mobile-filters__footer">
            <button className="main-button" onClick={closeModal}>
              Cerrar
            </button>
          </div>
        </Modal>
      }
    </div>
  )
}
